import { ProductSourceDtoSourceEnum } from "definitions/product-storage";
import { useEffect, useMemo, useState } from "react";

import { useProductDetailWithPrice } from "../hooks";
import { getActiveVariant } from "../utils";

export const useProductVariantsController = (
  id: string | null | undefined,
  platform: ProductSourceDtoSourceEnum | null,
) => {
  const { variants, isLoading, reload } = useProductDetailWithPrice(
    id,
    platform,
  );
  const [selected, setSelected] = useState<Record<string, string>>({});

  useEffect(() => {
    if (!variants) return;

    const initial: Record<string, string> = {};
    Object.entries(variants.attributes).forEach(
      ([attributeName, attributeValues]) => {
        if (attributeValues.length > 0) {
          initial[attributeName] = attributeValues[0];
        }
      },
    );

    setSelected(initial);
  }, [variants]);

  const activeVariant = useMemo(() => {
    if (!variants) return null;
    return getActiveVariant(variants, selected);
  }, [variants, selected]);

  return {
    variants,
    isLoading,
    selected,
    setSelected,
    activeVariant,
    reload,
  };
};
